export default __webpack_public_path__ + "static/media/czerwiec.3efb9f6a.mp3";